// import React, { useState, useEffect } from "react";
// import { Routes, Route, Navigate, useLocation } from "react-router-dom";
// import Sidebar from "./components/common/Sidebar";
// import "./styles/App.css";

// // Sales Management
// import Company from "./components/SalesManagement/company/Company";
// import Contact from "./components/SalesManagement/contact/Contact";
// import Tasks from "./components/SalesManagement/task/Tasks";
// import CompanyPreviewPage from "./components/SalesManagement/company/CompanyPreviewPage";
// import ContactPreviewPage from "./components/SalesManagement/contact/ContactPreviewPage";
// import TaskPreviewPage from "./components/SalesManagement/task/TaskPreviewPage";

// // Client Management
// import Client from "./components/ClientManagement/client/Client";

// // Admin
// import User from "./components/admin/User";
// import Dashboard from "./components/admin/admindashboard";
// import Reports from "./components/admin/Reports";

// // ATS
// import Jobs from "./components/ATS/Jobs";
import JobDetailsPage from "./components/ATS/JobDetailsPage";
// import Candidates from "./components/Candidates/Candidates";
// import ClientCandidateSharing from "./components/Candidates/ClientCandidateSharing";
// import ClientAccessPage from "./components/Candidates/ClientAccessPage";
// import InterviewSlotPage from "./components/Candidates/InterviewSlotPage";

// // Invoices
// import Invoices from "./components/invoices/Invoices";
// import Items from "./components/invoices/Items";
// import GenericInvoices from "./components/invoices/GenericInvoices";

// // Common
// import Profile from "./components/common/Profile";
// import Terms from "./components/common/Terms";
// import Login from "./components/auth/Login";
// import Forgot from "./components/auth/Forgot";
// import ResetPassword from "./components/auth/ResetPassword";
// import Register from "./components/auth/Register";

// // Super Admin
// import SuperAdmin from "./components/superadmin/SuperAdmin";
// import SuperAdminDashboard from "./components/superadmin/SuperAdminDashboard";

// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// // ── Role resolution ────────────────────────────────────────────────────────────
// const resolveEffectiveRole = () => {
//   const loginType = localStorage.getItem("loginType");

//   try {
//     const raw = localStorage.getItem("userProfile");
//     if (raw) {
//       const profile = JSON.parse(raw);
//       const profileRole =
//         profile.role || (Array.isArray(profile.roles) ? profile.roles[0] : null);
//       if (profileRole) {
//         return {
//           role: String(profileRole).toUpperCase().trim().replace(/^ROLE_/, ""),
//           isEmployee: loginType === "employee",
//         };
//       }
//     }
//   } catch { /* ignore */ }

//   const raw = localStorage.getItem("userRole") || "";
//   try {
//     const parsed = JSON.parse(raw);
//     const r = Array.isArray(parsed) ? parsed[0] : parsed;
//     return {
//       role: String(r).toUpperCase().trim().replace(/^ROLE_/, ""),
//       isEmployee: loginType === "employee",
//     };
//   } catch {
//     const r = raw.replace(/^[\]"]+|[\]"]+$/g, "").toUpperCase().trim().replace(/^ROLE_/, "");
//     return { role: r, isEmployee: loginType === "employee" };
//   }
// };

// function App() {
//   const [companies, setCompanies] = useState([]);
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [isInitializing, setIsInitializing] = useState(true);
//   const location = useLocation();

//   // ── Public bypass routes (no auth, no sidebar) ───────────────────────────
//   const isClientAccessPage   = location.pathname.startsWith("/clientaccesspage/");
//   const isInterviewSlotPage  = location.pathname.startsWith("/interview-slots/");

//   useEffect(() => {
//     const storedAuth = localStorage.getItem("isAuthenticated");
//     if (storedAuth === "true") setIsAuthenticated(true);
//     setIsInitializing(false);
//   }, []);

//   useEffect(() => {
//     localStorage.setItem("isAuthenticated", isAuthenticated ? "true" : "false");
//   }, [isAuthenticated]);

//   if (isInitializing) {
//     return (
//       <div className="app" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
//         <div>Loading...</div>
//       </div>
//     );
//   }

//   // ── Public: Client shareable link page ───────────────────────────────────
//   if (isClientAccessPage) {
//     return (
//       <div className="app">
//         <ToastContainer position="top-right" autoClose={3000} theme="light" />
//         <Routes>
//           <Route path="/clientaccesspage/:token" element={<ClientAccessPage />} />
//         </Routes>
//       </div>
//     );
//   }

//   // ── Public: Candidate interview slot selection page ───────────────────────
//   if (isInterviewSlotPage) {
//     return (
//       <div className="app">
//         <ToastContainer position="top-right" autoClose={3000} theme="light" />
//         <Routes>
//           <Route path="/interview-slots/:applicationId" element={<InterviewSlotPage />} />
//         </Routes>
//       </div>
//     );
//   }

//   // ── Resolve role ──────────────────────────────────────────────────────────
//   const { roles: effectiveRoles, isEmployee } = resolveEffectiveRole();

//   const isSuperAdmin     = effectiveRole === "SUPERADMIN";
//   const canAccessCRM     = !isSuperAdmin && (effectiveRole === "ADMIN" || effectiveRole === "CRM" || (!isEmployee && effectiveRole !== "ATS" && effectiveRole !== "INVOICE"));
//   const canAccessATS     = !isSuperAdmin && (effectiveRole === "ADMIN" || effectiveRole === "ATS");
//   const canAccessInvoice = !isSuperAdmin && (effectiveRole === "ADMIN" || effectiveRole === "INVOICE");
//   const canAccessAdmin   = !isSuperAdmin && (effectiveRole === "ADMIN" && !isEmployee);

//   const DefaultRedirect = () => {
//     if (isSuperAdmin)     return <Navigate to="/superadmin/dashboard" replace />;
//     if (canAccessCRM)     return <Company companies={companies} setCompanies={setCompanies} />;
//     if (canAccessATS)     return <Jobs />;
//     if (canAccessInvoice) return <Invoices />;
//     return <Profile />;
//   };

//   return (
//     <div className="app">
//       <ToastContainer position="top-right" autoClose={3000} theme="light" />

//       {!isAuthenticated ? (
//         <div className="auth-container">
//           <Routes>
//             <Route path="/"                       element={<Login setIsAuthenticated={setIsAuthenticated} />} />
//             <Route path="/forgot-password"        element={<Forgot />} />
//             <Route path="/reset-password/:userId" element={<ResetPassword />} />
//             <Route path="/terms"                  element={<Terms />} />
//             <Route path="/register"               element={<Register />} />
//             <Route path="*"                       element={<Navigate to="/" replace />} />
//           </Routes>
//         </div>
//       ) : (
//         <>
//           <Sidebar setIsAuthenticated={setIsAuthenticated} />
//           <div className="main-content">
//             <Routes>

//               {/* ── Default / root ── */}
//               <Route path="/" element={<DefaultRedirect />} />

//               {/* ── SUPERADMIN routes ── */}
//               {isSuperAdmin && (
//                 <>
//                   <Route path="/superadmin/dashboard" element={<SuperAdminDashboard />} />
//                   <Route path="/superadmin/users"     element={<SuperAdmin />} />
//                 </>
//               )}

//               {/* ── CRM / Sales routes ── */}
//               {canAccessCRM && (
//                 <>
//                   <Route path="/company"     element={<Company companies={companies} setCompanies={setCompanies} />} />
//                   <Route path="/company/:id" element={<CompanyPreviewPage />} />
//                   <Route path="/contacts"    element={<Contact />} />
//                   <Route path="/contact/:id" element={<ContactPreviewPage />} />
//                   <Route path="/tasks"       element={<Tasks />} />
//                   <Route path="/task/:id"    element={<TaskPreviewPage />} />
//                   <Route path="/clients"     element={<Client />} />
//                 </>
//               )}

//               {/* ── ATS routes ── */}
//               {canAccessATS && (
//                 <>
//                   <Route path="/ats/jobs"             element={<Jobs />} />
//                   <Route path="/ats/all-candidates"   element={<Candidates />} />
//                   <Route path="/ats/candidatesharing" element={<ClientCandidateSharing />} />
//                   <Route path="/clients"              element={<Client />} />
//                 </>
//               )}

//               {/* ── Invoice routes ── */}
//               {canAccessInvoice && (
//                 <>
//                   <Route path="/invoice"         element={<Invoices />} />
//                   <Route path="/items"           element={<Items />} />
//                   <Route path="/generic-invoice" element={<GenericInvoices />} />
//                 </>
//               )}

//               {/* ── Admin routes (non-employee ADMIN only) ── */}
//               {canAccessAdmin && (
//                 <>
//                   <Route path="/admin/dashboard" element={<Dashboard />} />
//                   <Route path="/admin/reports"   element={<Reports />} />
//                   <Route path="/admin/users"     element={<User />} />
//                 </>
//               )}

//               {/* ── Profile (everyone) ── */}
//               <Route path="/admin/profile" element={<Profile />} />

//               {/* ── Fallback ── */}
//               <Route path="*" element={<Navigate to="/" replace />} />

//             </Routes>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// export default App;

import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Sidebar from "./components/common/Sidebar";
import "./styles/App.css";

// Sales Management
import Company from "./components/SalesManagement/company/Company";
import Contact from "./components/SalesManagement/contact/Contact";
import Tasks from "./components/SalesManagement/task/Tasks";
import CompanyPreviewPage from "./components/SalesManagement/company/CompanyPreviewPage";
import ContactPreviewPage from "./components/SalesManagement/contact/ContactPreviewPage";
import TaskPreviewPage from "./components/SalesManagement/task/TaskPreviewPage";

// Client Management
import Client from "./components/ClientManagement/client/Client";
import ClientDetailsPage from "./components/ClientManagement/client/ClientDetailsPage";

// Admin
import User from "./components/admin/User";
import Reports from "./components/admin/Reports";
import ActionDashboard from "./components/admin/dashboard/ActionDashboard";

// ATS
import Jobs from "./components/ATS/Jobs";
import Candidates from "./components/Candidates/Candidates";
import CandidatePage from "./components/Candidates/CandidatePage";
import ClientCandidateSharing from "./components/Candidates/ClientCandidateSharing";
import ClientAccessPage from "./components/Candidates/ClientAccessPage";
import InterviewSlotPage from "./components/Candidates/InterviewSlotPage";

// Invoices
import Invoices from "./components/invoices/Invoices";
import Items from "./components/invoices/Items";
import GenericInvoices from "./components/invoices/GenericInvoices";

// Common
import Profile from "./components/common/Profile";
import Terms from "./components/common/Terms";
import Login from "./components/auth/Login";
import Forgot from "./components/auth/Forgot";
import ResetPassword from "./components/auth/ResetPassword";
import Register from "./components/auth/Register";
import OtpVerification from "./components/auth/OtpVerification";
import ChangePasswordPage from "./components/auth/ChangePasswordPage";

// Super Admin
import SuperAdmin from "./components/superadmin/SuperAdmin";
import SuperAdminDashboard from "./components/superadmin/SuperAdminDashboard";

// Settings
import TemplateLibrary from "./components/Templates/TemplateLibrary";
import Integrations from "./components/Settings/Integrations";
import FieldConfiguration from "./components/Settings/FieldConfiguration";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// ── Role resolution ────────────────────────────────────────────────────────────
const resolveEffectiveRole = () => {
  const loginType = localStorage.getItem("loginType");

  try {
    const raw = localStorage.getItem("userProfile");
    if (raw) {
      const profile = JSON.parse(raw);
      let profileRoles = [];
      if (Array.isArray(profile.roles) && profile.roles.length) {
        profileRoles = profile.roles.map(r => String(r).toUpperCase().trim().replace(/^ROLE_/, ""));
      } else if (profile.role) {
        profileRoles = [String(profile.role).toUpperCase().trim().replace(/^ROLE_/, "")];
      }
      if (profileRoles.length) {
        return {
          roles: profileRoles,
          isEmployee: loginType === "employee",
        };
      }
    }
  } catch { /* ignore */ }

  const raw = localStorage.getItem("userRole") || "";
  try {
    const parsed = JSON.parse(raw);
    const arr = Array.isArray(parsed) ? parsed : [parsed];
    return {
      roles: arr.map(r => String(r).toUpperCase().trim().replace(/^ROLE_/, "")),
      isEmployee: loginType === "employee",
    };
  } catch {
    const r = raw.replace(/^[\]"]+|[\]"]+$/g, "").toUpperCase().trim().replace(/^ROLE_/, "");
    return { roles: r ? [r] : [], isEmployee: loginType === "employee" };
  }
};

function App() {
  const [companies, setCompanies] = useState([]);

  // ── FIX: Read auth state synchronously so there's no flash on first render ──
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => localStorage.getItem("isAuthenticated") === "true"
  );
  const [mustChangePassword, setMustChangePassword] = useState(
    () => localStorage.getItem("mustChangePassword") === "true"
  );

  const location = useLocation();

  // ── Public bypass routes (no auth, no sidebar) ───────────────────────────
  const isClientAccessPage  = location.pathname.startsWith("/clientaccesspage/");
  const isInterviewSlotPage = location.pathname.startsWith("/interview-slots/");

  // Persist auth state whenever it changes
  useEffect(() => {
    localStorage.setItem("isAuthenticated", isAuthenticated ? "true" : "false");
  }, [isAuthenticated]);

  // ── Public: Client shareable link page ───────────────────────────────────
  if (isClientAccessPage) {
    return (
      <div className="app">
        <ToastContainer position="top-right" autoClose={3000} theme="light" />
        <Routes>
          <Route path="/clientaccesspage/:token" element={<ClientAccessPage />} />
        </Routes>
      </div>
    );
  }

  // ── Public: Candidate interview slot selection page ───────────────────────
  if (isInterviewSlotPage) {
    return (
      <div className="app">
        <ToastContainer position="top-right" autoClose={3000} theme="light" />
        <Routes>
          <Route path="/interview-slots/:applicationId" element={<InterviewSlotPage />} />
        </Routes>
      </div>
    );
  }

  // ── Resolve role ──────────────────────────────────────────────────────────
  const { roles: effectiveRoles, isEmployee } = resolveEffectiveRole();

  const isSuperAdmin     = effectiveRoles.includes("SUPERADMIN");
  const canAccessCRM     = !isSuperAdmin && (effectiveRoles.includes("ADMIN") || effectiveRoles.includes("CRM") || (!isEmployee && !effectiveRoles.includes("ATS") && !effectiveRoles.includes("INVOICE")));
  const canAccessATS     = !isSuperAdmin && (effectiveRoles.includes("ADMIN") || effectiveRoles.includes("ATS"));
  const canAccessInvoice = !isSuperAdmin && (effectiveRoles.includes("ADMIN") || effectiveRoles.includes("INVOICE"));
  const canAccessAdmin   = !isSuperAdmin && (effectiveRoles.includes("ADMIN") && !isEmployee);

  const DefaultRedirect = () => {
    if (isSuperAdmin) return <Navigate to="/superadmin/dashboard" replace />;
    return <Navigate to="/dashboard" replace />;
  };

  return (
    <div className="app">
      <ToastContainer position="top-right" autoClose={3000} theme="light" />

      {!isAuthenticated ? (
        <div className="auth-container">
          <Routes>
            <Route path="/"                       element={<Register />} />
            <Route path="/login"                  element={<Login setIsAuthenticated={setIsAuthenticated} setMustChangePassword={setMustChangePassword} />} />
            <Route path="/forgot-password"        element={<Forgot />} />
            <Route path="/reset-password"         element={<ResetPassword />} />
            <Route path="/terms"                  element={<Terms />} />
            <Route path="/register"               element={<Register />} />
            <Route path="/verify-email"           element={<OtpVerification />} />
            <Route path="*"                       element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      ) : mustChangePassword ? (
        <ChangePasswordPage onComplete={() => setMustChangePassword(false)} />
      ) : (
        <>
          <Sidebar setIsAuthenticated={setIsAuthenticated} />
          <div className="main-content">
            <Routes>

              {/* ── Default / root ── */}
              <Route path="/" element={<DefaultRedirect />} />

              {/* ── SUPERADMIN routes ── */}
              {isSuperAdmin && (
                <>
                  <Route path="/superadmin/dashboard" element={<SuperAdminDashboard />} />
                  <Route path="/superadmin/users"     element={<SuperAdmin />} />
                </>
              )}

              {/* ── CRM / Sales routes ── */}
              {canAccessCRM && (
                <>
                  <Route path="/company"     element={<Company companies={companies} setCompanies={setCompanies} />} />
                  <Route path="/company/:id" element={<CompanyPreviewPage />} />
                  <Route path="/contacts"    element={<Contact />} />
                  <Route path="/contact/:id" element={<ContactPreviewPage />} />
                  <Route path="/tasks"       element={<Tasks />} />
                  <Route path="/task/:id"    element={<TaskPreviewPage />} />
                  <Route path="/clients"     element={<Client />} />
                  <Route path="/clients/:id" element={<ClientDetailsPage />} />
                </>
              )}

              {/* ── ATS routes ── */}
              {canAccessATS && (
                <>
                  <Route path="/ats/jobs"             element={<Jobs />} />
                  <Route path="/ats/jobs/:id"         element={<JobDetailsPage />} />
                  <Route path="/ats/all-candidates"   element={<Candidates />} />
                  <Route path="/candidates/:id"       element={<CandidatePage />} />
                  <Route path="/ats/candidatesharing" element={<ClientCandidateSharing />} />
                  <Route path="/clients"              element={<Client />} />
                  <Route path="/clients/:id"          element={<ClientDetailsPage />} />
                </>
              )}

              {/* ── Invoice routes ── */}
              {canAccessInvoice && (
                <>
                  <Route path="/invoice"         element={<Invoices />} />
                  <Route path="/items"           element={<Items />} />
                  <Route path="/generic-invoice" element={<GenericInvoices />} />
                </>
              )}

              {/* ── Action Dashboard — all authenticated non-superadmin users ── */}
              {!isSuperAdmin && (
                <Route path="/dashboard" element={<ActionDashboard />} />
              )}

              {/* ── Admin routes (non-employee ADMIN only) ── */}
              {canAccessAdmin && (
                <>
                  <Route path="/admin/reports"       element={<Reports />} />
                  <Route path="/admin/users"         element={<User />} />
                  <Route path="/settings/templates"     element={<TemplateLibrary />} />
                  <Route path="/settings/integrations" element={<Integrations />} />
                  <Route path="/settings/fields"       element={<FieldConfiguration />} />
                </>
              )}

              {/* ── Profile (everyone) ── */}
              <Route path="/admin/profile" element={<Profile />} />

              {/* ── Fallback ── */}
              <Route path="*" element={<Navigate to="/" replace />} />

            </Routes>
          </div>
        </>
      )}
    </div>
  );
}

export default App;